
import {sysMessageLook} from "@/http/message";

export default {
  data() {
    return {

    }
  },
  methods: {
    toPageBySysMessage(row) {
      let loading = undefined;
      if (row.target_type) {
        loading = this.$loading({
          lock: true,
          text: '正在跳转中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }

      sysMessageLook({
        id: row.id
      }).then(res => {
        row.is_look = 1;
        loading && loading.close();

        // console.log('row', row);return;
        switch (row.target_type) {
          case 1:// 会诊室列表页
            this.$router.push(`/consultation_room`);
            break;

          case 2:// 资料卡列表
            // 根据点击的用户不同跳转到对应的页面
            // 医生和导师的病例通知会进这里

            let path = `/case_management?id=${row.patient_id}`;// 医生点击后跳转的路径
            if (row.member_id === row.mentor_id) {
              path = `/mentor_case_management?doctor_id=${row.doctor_id}&id=${row.patient_id}`;// 导师点击后跳转的路径
            }

            this.$router.push(path);
            break;
          case 3:// 病例大病案
            window.open(`/case_management/big_case?id=${row.patient_id}`,'_blank');
            break;

          case 4:// 订单详情
            this.$router.push(`/bill_center/detail?id=${row.order_id}`);
            break;

          case 5:// 大病案详情
            window.open(`/case_management/big_case?id=${row.patient_id}`,'_blank')
            break;

          case 6:// 资料卡对应的聊天框
            this.$router.push(`/case_management/talk?case_id=${row.patient_id}&card_id=${row.card_id}`);
            break;
          case 7:// 首诊卡
            this.$router.push(`/mentor_case_management?doctor_id=${row.doctor_id}&id=${row.patient_id}&card_id=${row.card_id}`);
            break;

          case 8:// 会诊群聊
            this.$router.push(`/consultation_room`);
            // this.$router.push(`/consultation_detail?meeting_id=${row.meeting_id}&case_id=${row.patient_id}&card_id=${row.card_id}`);
            break;
          case 9:// 外链
            window.open(row.target_url, '_blank');
            break;
        }
      })
    },
  }
}
